import { Body, Controller, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { AssociatesResponse, SchemaxDepartmentResponse, SchemaxEmployeesResponse } from '@schemax-whatsapp/shared-models';
import { SchemaxDbConnection } from '../db-connections/schemax-db-connection';
import { CompanyDeptRoleCategoryCodeRequest } from '../whatsapp-broad-cast/model/company-dept-role-cat.request';
import { SchemaxInfoService } from './schemax-info.service';

@Controller('schemax-info')
export class SchemaxInfoController {
  constructor(
    private applicationExceptionHandler: ApplicationExceptionHandler,
    private schemaxService: SchemaxInfoService,
  ) { }

  @Post('getSchemaxResources')
  async getSchemaxResources(@Body() req: CompanyDeptRoleCategoryCodeRequest): Promise<SchemaxEmployeesResponse> {
    try {
      return await this.schemaxService.getSchemaxResources(req);
    } catch (err) {
      console.log(err);
      return this.applicationExceptionHandler.returnException(SchemaxEmployeesResponse, err);
    }
  }

  @Post('getSchemaxVendors')
  async getSchemaxVendors(): Promise<SchemaxEmployeesResponse> {
    try {
      return await this.schemaxService.getSchemaxVendors();
    } catch (err) {
      console.log(err);
      return this.applicationExceptionHandler.returnException(SchemaxEmployeesResponse, err);
    }
  }

  @Post('getSchemaxCustomers')
  async getSchemaxCustomers(): Promise<SchemaxEmployeesResponse> {
    try {
      return await this.schemaxService.getSchemaxCustomers();
    } catch (err) {
      console.log(err);
      return this.applicationExceptionHandler.returnException(SchemaxEmployeesResponse, err);
    }
  }

  @Post('getSchemaxDepartments')
  async getSchemaxDepartments(): Promise<SchemaxDepartmentResponse> {
    try {
      return await this.schemaxService.getSchemaxDepartments();
    } catch (err) {
      return this.applicationExceptionHandler.returnException(SchemaxDepartmentResponse, err);
    }
  }

}
